<template>
    <div>
        <div class="pay-details" v-for="(item,index) in data" :key="index">
            <img src="../assets/img/icon/bonus.png" alt="">
            <div class="pay-details-right van-hairline--bottom">
                <div>
                    <p class="pay-details-type">{{item.reason}}</p>
                    <p class="pay-details-time">{{timeConvert(item.time,1)}}</p>
                </div>
                <p class="pay-details-price">+¥{{item.consum_point}}</p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props:{
            data:{
                type:Array,
                default:()=>[]
            }
        }
    }
</script>
<style scoped>
    .pay-details{
        padding-top: 30px;
        display: flex;
        padding-left: 30px;
    }
    .pay-details>img{
        width: 64px;
        height: 64px;
        margin-right: 20px;
    }
    .pay-details-right{
        display: flex;
        justify-content: space-between;
        align-items:center;
        width: 100%;
        padding-bottom: 30px;
        border-bottom: 1px solid #F0F0F0;
        padding-right: 30px;
    }
    .pay-details-type{
        font-size:26px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:37px;
        margin-bottom: 12px;
    }
    .pay-details-time{
        font-size:26px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(153,153,153,1);
        line-height:37px;
    }
    .pay-details-price{
        font-size:39px;
        font-family:PingFangSC-Medium;
        font-weight:600;
        color:rgba(255,25,25,1);
        line-height:70px;
    }
</style>